// extracted by mini-css-extract-plugin
export default {"write":"ReviewWrite_write__bB8KW","selectStarRegist":"ReviewWrite_selectStarRegist__i9AhA","productRating":"ReviewWrite_productRating__HTqUt"};